
import { MapConfig } from 'lib-customizations/types'

const mapConfig: MapConfig = {
  center: [60.86761, 26.70436],
  initialZoom: 13,
  addressZoom: 14,
  searchAreaRect: {
    maxLatitude: 61.16761906599942,
    minLatitude: 60.66761906599942,
    maxLongitude: 26.90435985687151,
    minLongitude: 26.20435985687151,
  },
  careTypeFilters: ['DAYCARE', 'PRESCHOOL', 'CLUB'],
  unitProviderTypeFilters: [
    'MUNICIPAL',
    'PURCHASED',
    'PRIVATE',
    'PRIVATE_SERVICE_VOUCHER',
  ],
}
export default mapConfig
